import { Entity } from 'engine/Entity';
import { ColliderFacet, ColliderType } from 'engine/facets/ColliderFacet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { create } from 'engine/lib/create';
import { CollisionLayer } from 'game/config';
import { LabWallSprite } from './LabWallSprite';

const layer = CollisionLayer.Wall;

export class LabWallEntity extends Entity {
  createFacets() {
    return [
      create(StaticSpriteFacet, { frame: LabWallSprite, offset: [0, -520] }),
      create(ColliderFacet, { type: ColliderType.Box, size: [640, 60], offset: [0, -60], layer }),
      create(ColliderFacet, { type: ColliderType.Box, size: [640, 60], offset: [860, -60], layer }),

      create(ColliderFacet, { type: ColliderType.Box, size: [40, 320], offset: [522, -88], layer }),
      create(ColliderFacet, { type: ColliderType.Box, size: [40, 320], offset: [942, -88], layer }),
    ];
  }
}
